module.exports = __webpack_public_path__ + "static/media/rj_result_lkyw1.8111c4d7.png";